import { Box, Grid, Theme, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { ReactChildren } from "../../interfaces/Common";
import Image from "../../Assets/assetHelper";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    height: "100%",
    minHeight: "100vh",
    width: "100%",
    overflow: "auto",
    position: "absolute",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundImage: `url(${Image.Images.AuthLayoutBg})`,
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
    "&::before": {
      content: '""',
      position: "absolute",
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
    },
    "& > div": {
      position: "relative",
      zIndex: 1,
      right: 0,
      textAlign: "center",
      color: theme.palette.KenColors.kenWhite,
    },
  },
  heading: {
    fontSize: 40,
    fontWeight: 700,
    color: theme.palette.KenColors.kenWhite,
    textTransform: "capitalize",
    textAlign: "left",
    width: "76%",
  },
  subHeading: {
    fontSize: 16,
    fontWeight: 400,
    color: theme.palette.KenColors.kenWhite,
    textAlign: "left",
    width: "76%",
  },
  formContainer: {
    position: "relative",
    zIndex: 2,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    height: "100% !important",
    minHeight: "100vh !important",
    width: "100%",
    alignItems: "center",
    background: "rgba(255, 255, 255, 0.9)",
    padding: "20px 0px",
    overflow: "auto",
  },
  layoutBar: {
    background: "#092682",
    height: "7px",
    width: "14%",
    margin: "10px 0px",
  },
  boxLayout: {
    marginLeft: "14%",
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
}));

const AuthLayout: React.FunctionComponent<ReactChildren> = ({ children }) => {
  const classes = useStyles();

  return (
    <Grid container className={classes.container}>
      <Grid item xs={12} md={6}>
        <Box component={"div"} className={classes.boxLayout}>
          <Typography className={classes.heading}>Impacting World Through Education</Typography>
          <div className={classes.layoutBar} />
          <Typography className={classes.subHeading}>At Ken42, we break bounds, find new challenges and provide only the best for institutions across the globe</Typography>{" "}
        </Box>
      </Grid>
      <Grid item xs={12} md={5} className={classes.formContainer}>
        {children}
      </Grid>
    </Grid>
  );
};

export default AuthLayout;
